// Generic gender personalization toggle.
// Reads the site-wide `personalize` cookie (women/men/unset) already set by
// personalizeByGender() in custom-global.js, then shows/hides any
// [data-gender="women"] / [data-gender="men"] element accordingly.
// When the cookie is unset (default visitor), every gendered element stays visible.
(function () {
  function applyGenderPersonalization(root) {
    var scope = root || document
    var genderEls = scope.querySelectorAll('[data-gender]')
    if (!genderEls.length) return

    var cookieMatch = document.cookie.match(/(?:^|;\s*)personalize=([^;]*)/)
    var cookieValue = cookieMatch ? decodeURIComponent(cookieMatch[1]) : ''
    var mode = (cookieValue === 'women' || cookieValue === 'men') ? cookieValue : 'default'

    genderEls.forEach(function (el) {
      var isMatch = mode === 'default' || el.dataset.gender === mode
      el.hidden = !isMatch
      el.classList.toggle('gender-personalization--hidden', !isMatch)
    })

    scope.dispatchEvent(new CustomEvent('gender-personalization:applied', { bubbles: true, detail: { mode: mode } }))
  }

  window.applyGenderPersonalization = applyGenderPersonalization

  document.addEventListener('DOMContentLoaded', function () {
    applyGenderPersonalization(document)

    // Some sections (e.g. is-land islands) hydrate their template content
    // after DOMContentLoaded, so watch for newly inserted [data-gender]
    // elements and apply the toggle to them too.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes
        for (var j = 0; j < added.length; j++) {
          var node = added[j]
          if (node.nodeType !== 1) continue
          if (node.hasAttribute && node.hasAttribute('data-gender')) {
            applyGenderPersonalization(document)
            return
          }
          if (node.querySelector && node.querySelector('[data-gender]')) {
            applyGenderPersonalization(document)
            return
          }
        }
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })
  })
})()
